import { useTheme } from '@mui/material/styles'
import { useStytchMemberSession } from '@stytch/react/b2b'
import { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { LoginOrSignup } from './LoginOrSignup'

import type { FC } from 'react'

export const Authenticate: FC = () => {
	const { session } = useStytchMemberSession()
	const alreadyLoggedInRef = useRef<boolean | undefined>(undefined)
	const [shouldRedirect, setShouldRedirect] = useState(false)
	const theme = useTheme()

	useEffect(() => {
		if (alreadyLoggedInRef.current === undefined) {
			alreadyLoggedInRef.current = !!session
			if (session) setShouldRedirect(true)
		}
	}, [session])

	if (shouldRedirect) {
		return <Navigate to="/dashboard" replace />
	}

	return (
		<div
			style={{
				minHeight: '100dvh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: theme.palette.background.default,
				padding: '24px',
			}}
		>
			<div
				style={{
					width: '100%',
					maxWidth: 420,
				}}
			>
				<LoginOrSignup />
			</div>
		</div>
	)
}
